import {onBeforeUnmount, ref} from '@vue/composition-api'

/**
 * Returns a function to `setTimeout` with cleanup on component unmount.
 */
export default function useTimeouts () {
  const handle = ref()

  onBeforeUnmount(() => {
    if (handle.value) clearTimeout(handle.value)
  })

  return set

  function set (handler, timeout) {
    handle.value = setTimeout(() => {
      handle.value = undefined
      handler()
    }, timeout)
  }
}
